function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.315 8.173a6.859 6.859 0 1113.717 0 6.859 6.859 0 01-13.717 0zm6.858-5.289a5.295 5.295 0 00-5.29 5.29 5.296 5.296 0 005.29 5.289 5.296 5.296 0 005.29-5.29 5.296 5.296 0 00-5.29-5.289zm5.98 10.16l4.597 4.596-1.11 1.11-4.596-4.597.145-.124a7.78 7.78 0 00.84-.84l.124-.145z",
    fill: props.color
  }));
}

export default SvgSearch;